module.exports = __webpack_public_path__ + "img/student.cad279e3.png";